/* @ngInject */
function workflowService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    getWorkflowHomeTabsCounts,
    getWorkflowHomeInsights
  }
  return service

  function getWorkflowHomeTabsCounts () {
    const url = CONSTANTS.URL_USERS_ME_WORKFLOW_HOME_COUNT
    return ConnectorWebService.get(url)
  }

  function getWorkflowHomeInsights (periodStart) {
    const url = Utils.fnAddQueryToUrl(CONSTANTS.URL_USERS_ME_WORKFLOW_HOME_INSIGHTS, { $periodStart: periodStart })

    return ConnectorWebService.get(url)
  }
}

export { workflowService }
